import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { Toggle } from '@/components/ui/toggle';
import { cn } from '@/lib/utils';
import { useI18n } from '@/locales/client';
export function SearchWidget(t0) {
  const $ = _c(31);
  const {
    value,
    isUsingRegex: t1,
    onSearch,
    onRegex,
    className: t2
  } = t0;
  const isUsingRegex = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const t = useI18n();
  const inputRef = useRef(null);
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => {
      if (document.activeElement === inputRef.current) {
        return;
      }
      e.preventDefault();
      const el = inputRef.current;
      if (el) {
        el.focus();
        el.select();
      }
    };
    t4 = {
      enableOnFormTags: ["textarea", "input"]
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  useHotkeys("meta+f", t3, t4);
  let t5;
  if ($[2] !== className) {
    t5 = cn("flex max-w-48 flex-row items-center gap-1 overflow-visible rounded-md border p-1.5 pr-1.25 dark:text-neutral-400", "shadow-xs [--sq-r:.75rem] sq:rounded-(--sq-r) sq:shadow-none sq:drop-shadow-xs", "transition-[color,box-shadow,border-color] has-[>:focus]:border-ring has-[>:focus]:ring-[3px] has-[>:focus]:ring-ring/50", className);
    $[2] = className;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="icon-[ion--search] size-4 text-neutral-500 dark:text-neutral-400" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== onSearch) {
    t7 = e_0 => {
      onSearch(e_0.target.value);
    };
    $[5] = onSearch;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t) {
    t8 = t("search");
    $[7] = t;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = !value && "select-none";
  let t10;
  if ($[9] !== t9) {
    t10 = clsx("w-[.1%] grow bg-transparent pl-0.5 leading-4 outline-hidden dark:placeholder:text-neutral-600", t9);
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t7 || $[13] !== t8 || $[14] !== value) {
    t11 = <input ref={inputRef} type="text" aria-label="Search" value={value} onChange={t7} placeholder={t8} className={t10} />;
    $[11] = t10;
    $[12] = t7;
    $[13] = t8;
    $[14] = value;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== onSearch || $[17] !== value) {
    t12 = value ? <svg className="icon-[ep--circle-close-filled] size-4.25 text-neutral-700 dark:text-neutral-300" onClick={() => {
      onSearch("");
    }} /> : null;
    $[16] = onSearch;
    $[17] = value;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== isUsingRegex || $[20] !== onRegex) {
    t13 = () => {
      onRegex(!isUsingRegex);
    };
    $[19] = isUsingRegex;
    $[20] = onRegex;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <svg className="icon-[codicon--regex] size-4.5" />;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== isUsingRegex || $[24] !== t13) {
    t15 = <div className="inline-flex items-center"><Toggle pressed={isUsingRegex} aria-label="Regular expression" className="size-fit min-w-0 touch-manipulation rounded-[3px] p-px text-muted-foreground" onPressedChange={t13}>{t14}</Toggle></div>;
    $[23] = isUsingRegex;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t15 || $[29] !== t5) {
    t16 = <div className={t5}>{t6}{t11}{t12}{t15}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t15;
    $[29] = t5;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}